<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="车间">
              <a-select v-model="queryParams.workshopCodes" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
                  {{ item.workshopCode }}-{{ item.workshopDesc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单号">
              <a-input v-model="queryParams.wipEntityNameVal" allowClear placeholder="支持Excel复制批量搜索" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectMultiple"
                :selectData="statusList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.assemblyItemIdList"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24"  v-if="advanced">
            <a-form-item label="产线">
              <global-select
                :value.sync="queryParams.lineIdList"
                selectType="selectMultiple"
                :selectData="lineCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="加工组织">
              <a-select v-model="queryParams.desOrganizationCode" allowClear>
                <a-select-option v-for="item in desOrganizationNameList" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="审批状态">
              <global-select
                :value.sync="queryParams.approvalStatusList"
                selectType="selectMultiple"
                :selectData="approvalStatusList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="工单分类">
              <global-select
                :value.sync="queryParams.classCodeList"
                selectType="selectMultiple"
                :selectData="classCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划单号">
              <a-input v-model="queryParams.orderNoVal" allowClear placeholder="支持Excel复制批量搜索" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="创建人">
              <global-select
                :value.sync="queryParams.createBy"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/founderBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="jobCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划开始时间">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.scheduledStartDate"
                  @change="handleScheduledStartDateChange"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划完成时间">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.scheduledCompletionDate"
                  @change="handleScheduledCompletionDateChange"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="需求组织">
              <a-tooltip>
                <a-input v-model="queryParams.finishedProductJobOrg"></a-input>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="是否分仓">
              <global-select
                :value.sync="queryParams.warehouseFlag"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SYS_YES_NO' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="一次达交考核时间" :labelCol="{ style: { width: '120px' } }">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.deliveryDate"
                  @change="handleDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="下达时间">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.releaseDate"
                  @change="handleReleaseDateChange"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="组件物料">
              <global-select
                ref="materils"
                v-model="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ organizationCode: 'A001' }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="考核交期">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.assessmentDeliveryDate"
                  @change="handleAssessmentDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="未完成数量交期" :labelCol="{ style: { width: '120px' } }">
              <a-tooltip>
                <a-range-picker
                  v-model="cacheParams.estimatedDeliveryDate"
                  @change="handleEstimatedDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="handleQuery('查询')" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper line-height37" slot="btn">
      <a-button @click="handleFf(selectedRowKeys)" :loading="btnLoadingObj.isGrantLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:grant']">发放</a-button>
      <a-button :loading="btnLoadingObj.isReleaseAndDispatchRecallLoading" @click="handleFfFgch(selectedRows)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:releaseAndDispatchRecall']">发放&派工撤回</a-button>
      <a-button @click="handleconfirm(selectedRows)" :loading="confirmLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:submitTo']">提交</a-button>
      <download-modal :apiFun="exportUrl" ref="download" />
      <a-button @click="handleExport" type="primary" v-hasPermi="['mes:mesDiscreteJobs:dispatchExport']">导出</a-button>
      <a-button type="primary" @click="handlePg(selectedRows)" :loading="pgLoading" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:add']">派工</a-button>
      <a-button type="primary" @click="handlePgzl(selectedRows)" :disabled="selectedRowKeys.length === 0" :loading="pgzlLoading" v-hasPermi="['mes:mesDispatch:printDispatchInformation']">打印派工资料</a-button>
      <a-button ref="sendMaterialsBtn" v-show="false" v-print="'#sendMaterialsId'">打印派工资料</a-button>
      <a-button type="primary" @click="handleHezBq(selectedRows)" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:printCertificateOfConformityPage']">打印合格证/标签</a-button>
      <a-button type="primary" @click="handleHardwarePrint(selectedRows)" :disabled="selectedRowKeys.length === 0" :loading="hardwareLoading" v-hasPermi="['mes:mesDispatch:getHardwarePrintDetail']">打印五金箱标签</a-button>
      <a-button ref="hardwareLabelBtn" v-show="false" v-print="'#hardwareLabelId'">打印五金箱标签</a-button>
      <a-button @click="handleKg(selectedRows)" :loading="kgLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:startWork']">开工</a-button>
      <a-button @click="handleBglbj(selectedRows)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:workReportingParts']">报工-零部件</a-button>
      <a-button @click="handleWglbj(selectedRows)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:wipCompletion']">入库-零部件</a-button>
      <a-button @click="handleCpzj(selectedRows)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:inspectionAssemblyCenter']">成品质检</a-button>
      <a-button :loading="btnLoadingObj.isCompletionAssemblyCenterPageLoading" @click="handleWgzzzx(selectedRows)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:completionAssemblyCenter']">完工-组装中心</a-button>
      <a-button @click="handleClose(selectedRowKeys)" type="primary" :loading='btnLoadingObj.isRowCloseBtnLoading' :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:close']">关闭工单</a-button>
      <a-button @click="handleRefresh" type="primary" v-hasPermi="['mes:mesDispatch:refreshPackageVersion']" :disabled="selectedRowKeys.length === 0">刷新包装版本</a-button>
      <refresh-version-modal ref="RefreshVersionModalRef" @reSearch="handleOk" />
      <a-button type="primary" :loading="deliveryLoading" @click="handleUpdateAssessmentDelivery" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:submitAssessment']">修改考核交期</a-button>
      <update-assessment-delivery-date ref="updateAssessmentDeliveryDateRef" @reSearch="handleOk" />
      <a-button @click="handlePrintPicking" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDispatch:getMaterialPrintList']">打印领料单</a-button>
      <a-button type="primary" :loading="drawingDownloadLoading" :disabled="selectedRowKeys.length === 0" @click="handleDownloadDrawing" v-hasPermi="['mes:mesDispatch:downloadDrawing']">下载工艺图纸</a-button>
      <pick-material-modal ref="pickMaterialModalRef" />
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs :default-active-key="currentTab" type="card" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.key"></a-tab-pane>
        </a-tabs>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 3000 }"
          @selectedRowChange="selectedRowChange"
          @change="handleTableChange"
        >
          <template #scheduledStartDateTitle>
            <span>计划开始时间</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('scheduledStartDate')" type="edit" title="编辑"/>
          </template>
          <template #scheduledCompletionDateTitle>
            <span>计划完成时间</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('scheduledCompletionDate')" type="edit" title="编辑"/>
          </template>
          <template #dateEditAfterTodayTitle>
            <span>未完成数量交期</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('estimatedDeliveryDate')" type="edit" title="编辑"/>
          </template>
          <template slot="fixedEllipsis" slot-scope="{text}">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ text }}</span>
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-tooltip>
          </template>
          <template slot="drawingVersion" slot-scope="text">
            <span>{{ text.text || '-' }}</span>
          </template>
          <template slot="scheduledStartDate" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              size="small"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled="sList.includes(text.record.status) || text.record.wipEntityFlag === 'FINISHED_PRODUCT_JOB'"
            />
          </template>
          <template slot="scheduledCompletionDate" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              size="small"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled="sList.includes(text.record.status) || text.record.wipEntityFlag === 'FINISHED_PRODUCT_JOB'"
            />
          </template>
          <template slot="releaseDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="dispatchingDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="startDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="completionDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="deliveryDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="approvalDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="dateRequired" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="formatDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <!--考核交期-零部件和成品区别展示-->
          <template slot="assessmentDeliveryDate" slot-scope="{ text, record }">
            <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="dateEditAfterToday" slot-scope="{ text, record, column }">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === record.id"
              v-model="record[column.dataIndex]"
              valueFormat="YYYY-MM-DD 00:00:00"
              size="small"
              :disabled-date="disabledDate"
            />
          </template>
          <template slot="desOrganizationName" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.desOrganizationName }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.desOrganizationCode" size="small" :disabled="sList.includes(text.record.status) || text.record.wipEntityFlag === 'FINISHED_PRODUCT_JOB' || text.record.wipEntityFlag === 'COMPONENT_JOB'">
              <a-select-option v-for="(item) in desOrganizationNameList" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </template>
          <template slot="workCode" slot-scope="{ record }" >
            <span v-if="!isEdit || currentId !== record.id">{{ record.workCode }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.workCode"
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: record.desOrganizationCode }"
              :allowClear="false"
              size="small"
              :disabled="sList.includes(record.status)"
              :dropdown-match-select-width="false"
              @change="workCodeChange(record)"
            />
          </template>
          <template slot="lineCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.lineCode }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.lineCode"
              requestApi="/mes/mesDiscreteJobs/lineCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ workCode: record.workCode }"
              :allowClear="false"
              size="small"
              :disabled="sList.includes(record.status)"
              :dropdown-match-select-width="false"
            />
          </template>
          <template slot="mrpFlag" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mrpFlag }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.mrpFlag" size="small" :disabled="sList.includes(text.record.status)">
              <a-select-option v-for="(item) in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
      <work-order-sent-pg
        ref="createModal"
        @handle-success="handleOk"
      />
      <print-certificate ref="printCertificate" />
      <div class="display-none">
        <print-send-materials v-if="showPintSendMaterial" ref="sendMaterialsRef" id="sendMaterialsId" />
        <hardware-label-print ref="hardwareLabelPrintRef" id="hardwareLabelId" />
      </div>
      <BatchEditModal ref="BatchEditModalRef" @click="handleOk" />
      <work-order-sent-bglbj ref="bglbjDialog" @handle-success="handleOk" />
      <work-order-sent-wglbj ref="wglbjDialog" @handle-success="handleOk" />
      <work-order-sent-cpzj ref="cpzjDialog" @handle-success="handleOk" />
      <work-order-sent-wgzzzx ref="wgzzzxDialog" @handle-success="handleOk" />
      <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk2" />
      <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';
import {
  apiMesDiscreteJobsDispatchList,
  apiMesRequirementOperationsDispatchList,
  apiMesOperationsDispatchList,
  apiMesDiscreteJobsDispatchAssociatedWorkOrderList,
  apiUserInventOrg,
  apiMesDiscreteJobsWorkCodeBox,
  apiMesDiscreteJobsLineCodeBox,
  apiMesDiscreteJobsUpdate,
  apiMesDiscreteJobsClassCodeBox,
  apiMesDiscreteJobsGrant,
  apiMesDispatchReleaseDispatchRecall,
  apiMesDispatchStartWork,
  apiMesDispatchWorkReportingPartsPage,
  apiMesDispatchWipCompletionPage,
  apiMesDispatchAdd,
  apiMesDispatchPrintDispatchInformation,
  apiMesDiscreteJobsSubmitTo,
  apiScpScreeningSchemeSearchAllScheme,
  apiDiscreteJobsExport,
  apiAssociatedWorkOrderExport,
  apiRequirementOperationsExport,
  apiMesOperationsExport,
  apiMesDiscreateBatchClose,
  apiMesDispatchDownloadDrawing
} from '@/api/mes/workOrderManage/workOrderSent'
import BatchEditModal from './components/batch-edit-modal'
import WorkOrderSentPg from './components/work-order-sent-pg'
import PrintSendMaterials from './components/print-send-materials'
import PrintCertificate from './components/print-certificate'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import WorkOrderSentBglbj from './components/work-order-sent-bglbj'
import WorkOrderSentWglbj from './components/work-order-sent-wglbj'
import WorkOrderSentCpzj from './components/work-order-sent-cpzj'
import WorkOrderSentWgzzzx from './components/work-order-sent-wgzzzx'
import hardwareLabelPrint from './components/hardware-label-print'
import cacheRequest from '@/mixins/cacheRequest'
import { generateLsTableResData } from '@/utils/util.js'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import deepClone from "lodash.clonedeep";
import RefreshVersionModal from "@/views/mes/workOrderManage/workOrderDesk/components/refresh-version-modal.vue"
import updateAssessmentDeliveryDate from "@/views/mes/workOrderManage/workOrderDesk/components/update-assessment-delivery-date.vue"
import pickMaterialModal from "@/views/mes/workOrderManage/workOrderDesk/components/pick-material-modal.vue"
import { apiBomWorkshopFindList } from '@/api/mes/basedata/factoryAssembly'
import {
  apiCheckAssessmentDeliveryDateCanSubmit,
  apiGetHardwarePrintDetail
} from '@/api/mes/workOrderManage/workOrderDesk'

export default {
  name: 'WorkOrderSent', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    WorkOrderSentPg,
    PrintSendMaterials,
    PrintCertificate,
    WorkOrderSentBglbj,
    WorkOrderSentWglbj,
    WorkOrderSentCpzj,
    WorkOrderSentWgzzzx,
    DressingByScreening,
    DownloadModal,
    DressingByScreeningSetUp,
    RefreshVersionModal,
    updateAssessmentDeliveryDate,
    BatchEditModal,
    hardwareLabelPrint,
    pickMaterialModal
  },
  mixins: [cacheRequest],
  data () {
    return {
      deliveryLoading: false, // 考核交期loading
      cacheEditObj: null, // 缓存当前编辑的行数据
         // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMesDiscreteJobsDispatchList, true),
        pageCurrent: true
      },
      workshopCodeList: [], // 车间编码
      exportUrl: () => {}, // 导出接口
      isEdit: false,
      currentId: "",
       // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        itemIdList: undefined,
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        statusList: undefined,
        assemblyItemIdList: undefined,
        lineIdList: undefined,
        desOrganizationCode: undefined,
        classCodeList: undefined,
        orderNoVal: undefined,
        orderNoList: undefined,
        createBy: undefined,
        workshopCodes: undefined,
        staScheduledCompletionDate: undefined,
        endScheduledCompletionDate: undefined,
        staScheduledStartDate: undefined,
        endScheduledStartDate: undefined,
        staEstimatedDeliveryDate: undefined,
        endEstimatedDeliveryDate: undefined,
        approvalStatusList: undefined
      },
      cacheParams: {
        scheduledStartDate: [],
        scheduledCompletionDate: [],
        deliveryDate: [],
        releaseDate: [],
        assessmentDeliveryDate: [], // 考核交期
        estimatedDeliveryDate: [] // 未完成数量交期
      },
      showPintSendMaterial: false, // 控制打印派料显隐
      // 快码表格数据
      typeList: [],
      tableLoading: false,
      columns: [],
      // 表格字段-工单信息
      columns1: [
        { title: '工单号', fixed: 'left', width: 170, dataIndex: 'wipEntityName', align: 'center' },
        { title: '计划单号', width: 200, dataIndex: 'orderNo', align: 'center', fixed: 'left' },
        { title: '工单状态', width: 120, dataIndex: 'statusName', align: 'center', sorter: true },
        { title: '审批状态', width: 120, dataIndex: 'approvalStatusName', align: 'center' },
        { title: '物料名称', width: 240, dataIndex: 'itemName', align: 'center', ellipsis: true },
        { title: '规格描述', width: 500, dataIndex: 'description', align: 'center', ellipsis: true },
        { title: '计划数量', width: 100, dataIndex: 'planQuantity', align: 'center' },
        {
          // title: '未完成数量交期',
          dataIndex: 'estimatedDeliveryDate',
          scopedSlots: { customRender: 'dateEditAfterToday', title: "dateEditAfterTodayTitle" },
          width: 175,
          align: 'center'
        },
        {
          // title: '计划开始时间',
          dataIndex: 'scheduledStartDate',
          scopedSlots: { customRender: 'scheduledStartDate', title: "scheduledStartDateTitle" },
          width: 170,
          align: 'center',
          sorter: true
        },
        {
          // title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          scopedSlots: { customRender: 'scheduledCompletionDate', title: "scheduledCompletionDateTitle" },
          width: 170,
          align: 'center',
          sorter: true
        },
        { title: '下达时间', dataIndex: 'releaseDate', scopedSlots: { customRender: 'releaseDate' }, width: 150, align: 'center', sorter: true },
        { title: '派工时间', dataIndex: 'dispatchingDate', scopedSlots: { customRender: 'dispatchingDate' }, width: 150, align: 'center' },
        { title: '开工时间', dataIndex: 'startDate', scopedSlots: { customRender: 'startDate' }, width: 150, align: 'center' },
        { title: '完工时间', dataIndex: 'completionDate', scopedSlots: { customRender: 'completionDate' }, width: 150, align: 'center' },
        { title: '入库时间', dataIndex: 'receivedDate', scopedSlots: { customRender: 'receivedDate' }, width: 150, align: 'center' },
        { title: '一次达交考核时间', dataIndex: 'deliveryDate', scopedSlots: { customRender: 'deliveryDate' }, width: 150, align: 'center', sorter: true },
        { title: '变更后考核交期', dataIndex: 'assessmentDeliveryDate', scopedSlots: { customRender: 'assessmentDeliveryDate' }, width: 150, align: 'center', ellipsis: true },
        { title: '第一次报工时间', width: 160, scopedSlots: { customRender: 'formatDate' }, dataIndex: 'firstReportingTime', align: 'center' },
        { title: '完工数量', width: 120, dataIndex: 'quantityCompleted', align: 'center' },
        { title: '剩余数量', width: 120, dataIndex: 'quantityRemaining', align: 'center' },
        { title: '已入库数量', width: 120, dataIndex: 'receivedQuantity', align: 'center' },
        { title: '已送货数量', width: 120, dataIndex: 'deliveredQuantity', align: 'center', ellipsis: true },
        { title: '交期变更套数', width: 120, dataIndex: 'assessmentChangeQuantity', align: 'center' },
        { title: '单位', width: 100, dataIndex: 'primaryUomCode', align: 'center' },
        { title: '完工子库', width: 120, dataIndex: 'completedSublibrary', align: 'center' },
        { title: '完工货位', width: 120, dataIndex: 'completedLocation', align: 'center' },
        { title: '物料编码', width: 160, dataIndex: 'itemCode', align: 'center', ellipsis: true },
        { title: '工单类型', width: 110, dataIndex: 'jobTypeName', align: 'center' },
        { title: '工单分类', width: 110, dataIndex: 'classCode', align: 'center', ellipsis: true },
        { title: '大货类型', width: 110, dataIndex: 'orderTypeName', align: 'center', ellipsis: true },
        { title: '需求组织', width: 180, dataIndex: 'finishedProductJobOrg', align: 'center', ellipsis: true },
        { title: '加工组织', dataIndex: 'desOrganizationName', scopedSlots: { customRender: 'desOrganizationName' }, width: 180, align: 'center' },
        { title: '车间', dataIndex: 'workCode', scopedSlots: { customRender: 'workCode' }, width: 150, align: 'center' },
        { title: '产线', dataIndex: 'lineCode', scopedSlots: { customRender: 'lineCode' }, width: 150, align: 'center' },
        { title: '签价单号', dataIndex: 'alternativeMaterialList', scopedSlots: { customRender: 'alternativeMaterialList' }, width: 150, align: 'center', ellipsis: true },
        { title: 'BOM版本号字段', dataIndex: 'bomVersion', scopedSlots: { customRender: 'bomVersion' }, width: 150, align: 'center', ellipsis: true },
        { title: '包装BOM版本号', dataIndex: 'packageVersion', scopedSlots: { customRender: 'packageVersion' }, width: 150, align: 'center', ellipsis: true },
        { title: 'MRP净值', dataIndex: 'mrpFlag', scopedSlots: { customRender: 'mrpFlag' }, width: 130, align: 'center' },
        { title: '审批时间', dataIndex: 'approvalDate', scopedSlots: { customRender: 'approvalDate' }, width: 150, align: 'center' },
        { title: '是否分仓', width: 100, dataIndex: 'warehouseFlag', align: 'center', ellipsis: true },
        { title: '是否打印标签', width: 100, dataIndex: 'printFlag', align: 'center', ellipsis: true },
        { title: '佛山仓数量', width: 100, dataIndex: 'currentCpDivideQty', align: 'center' },
        { title: '基地仓数量', width: 100, dataIndex: 'currentJdcDivideQty', align: 'center' },
        { title: '拖套比', width: 100, dataIndex: 'trayRatioQty', align: 'center' },
        { title: '佛山专货仓数量', width: 110, dataIndex: 'currentFszhcDivideQty', align: 'center' },
        { title: '工厂检验结果', width: 100, dataIndex: 'qualifiedFlag', align: 'center' },
        { title: 'QC检验结果', width: 100, dataIndex: 'qcQualifiedFlag', align: 'center' },
        { title: '是否锁库', width: 100, dataIndex: 'lockStockFlag', align: 'center' },
        { title: '备注', width: 120, dataIndex: 'remarks', align: 'center', ellipsis: true },
        { title: '取消原因', width: 120, dataIndex: 'cancelReason', align: 'center', ellipsis: true },
        { title: '创建人', width: 100, dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'updateTime' }, width: 150, align: 'center' },
        { title: '标准图纸版本', dataIndex: 'drawingVersion', scopedSlots: { customRender: 'drawingVersion' }, width: 140, align: 'center', ellipsis: true }
      ],
      // 表格字段-工单用料表
      columns2: [
        { title: '工单号', width: 170, fixed: 'left', dataIndex: 'wipEntityName', align: 'center' },
        { title: '成品-物料编码', width: 160, fixed: 'left', dataIndex: 'itemCode', align: 'center' },
        { title: '成品-物料名称', width: 120, dataIndex: 'productName', align: 'center' },
        { title: '成品-规格描述', width: 500, dataIndex: 'description', align: 'center', ellipsis: true },
        { title: '组件物料', width: 160, dataIndex: 'roItemCode', align: 'center' },
        { title: '组件-物料名称', width: 260, dataIndex: 'roItemName', align: 'center', ellipsis: true },
        { title: '组件-规格描述', width: 500, dataIndex: 'zuDescription', align: 'center', ellipsis: true },
        { title: '单位', width: 120, dataIndex: 'primaryUomCode', align: 'center' },
        { title: '用量', width: 120, dataIndex: 'quantityPerAssembly', align: 'center' },
        { title: '产出率', width: 120, dataIndex: 'componentYield', align: 'center' },
        { title: '必须', width: 120, dataIndex: 'requiredQuantity', align: 'center' },
        { title: '已发料', width: 120, dataIndex: 'quantityIssued', align: 'center' },
        { title: '未发料', width: 120, dataIndex: 'quantityOpen', align: 'center' },
        { title: '供应类型', width: 120, dataIndex: 'wipSupplyTypeName', align: 'center' },
        { title: '集采类型', width: 120, dataIndex: 'purchaseTypeName', align: 'center' },
        { title: 'MRP净值', width: 120, dataIndex: 'mrpFlag', align: 'center' },
        { title: '供应子库', width: 120, dataIndex: 'supplySublibrary', align: 'center' },
        { title: '供应货位', width: 120, dataIndex: 'supplyLocation', align: 'center' },
        { title: '需求日期', dataIndex: 'dateRequired', scopedSlots: { customRender: 'dateRequired' }, width: 150, align: 'center' },
        { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'updateTime' }, width: 150, align: 'center' }
      ],
      // 表格字段-工单工序
      columns3: [
        { title: '工单号', width: 180, fixed: 'left', dataIndex: 'wipEntityName', align: 'center' },
        { title: '工单状态', width: 120, dataIndex: 'statusName', align: 'center' },
        { title: '审批状态', width: 120, dataIndex: 'approvalStatusName', align: 'center' },
        { title: '物料编码', width: 160, dataIndex: 'itemCode', align: 'center' },
        { title: '物料名称', width: 260, dataIndex: 'itemName', align: 'center' },
        { title: '规格描述', width: 500, dataIndex: 'description', align: 'center', ellipsis: true },
        { title: '工序序号', width: 120, dataIndex: 'operationSeqNum', align: 'center' },
        { title: '工序代码', width: 120, dataIndex: 'operationCode', align: 'center' },
        { title: '工序说明', width: 120, dataIndex: 'operationDesc', align: 'center' },
        { title: '工序类型', width: 120, dataIndex: 'operationTypeName', align: 'center' },
        { title: '工序开工时间', dataIndex: 'processStartTime', width: 150, align: 'center' },
        { title: '车间', width: 120, dataIndex: 'workCode', align: 'center' },
        { title: '生产线', width: 120, dataIndex: 'lineCode', align: 'center' },
        { title: '流转状态', width: 120, dataIndex: 'status', align: 'center' },
        { title: '需求数量', width: 120, dataIndex: 'requiredQty', align: 'center' },
        { title: '等待数量', width: 120, dataIndex: 'waitQty', align: 'center' },
        { title: '完成数量', width: 120, dataIndex: 'completedQty', align: 'center' },
        { title: '第一次工序报工时间', dataIndex: 'firstReportingTime', width: 170, align: 'center' },
        { title: '最后一次工序报工时间', dataIndex: 'lastReportingTime', width: 170, align: 'center' },
        { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'updateTime' }, width: 150, align: 'center' }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 页签
      currentTab: "工单信息",
      tabList: [
        { key: "工单信息" },
        { key: "工单用料表" },
        { key: "工单工序" },
        { key: "关联工单" }
      ],
      scrollWidth: 4200,
      // MRP净值
      yesOrNo: [
        { key: "Y", value: "是" },
        { key: "N", value: "否" }
      ],
      searchList1: [],
      searchList2: [],
      desOrganizationNameList: [], // 加工组织
      workCodeList: [], // 车间
      lineCodeList: [], // 产线
      classCodeList: [], // 工单分类
      approvalStatusList: [], // 审批状态
      statusList: [], // 工单状态
      pgzlLoading: false,
      drawingDownloadLoading: false,
      hardwareLoading: false, // 五金打印标签loading
      sList: ["ISSUED", "DISPATCHED", "START_WORK", "COMPLETED", "SUSPENDED", "ABNORMAL_COMPLETION", "CANCELED"],
      orderNos: [],
      pgzlList: ["DISPATCHED", "START_WORK", "COMPLETED", "ABNORMAL_COMPLETION", "CLOSED", "RECEIVED"], // 已派工、已开工、已完成、异常完成、已关闭
      btnLoadingObj: {
        isGrantLoading: false, // 发放按钮loading
        isReleaseAndDispatchRecallLoading: false, // 发放&派工撤回按钮loading
        isSubmitToLoading: false, // 提交按钮loading
        isAddLoading: false, // 派工按钮loading
        isStartWorkLoading: false, // 开工按钮loading
        isWorkReportingPartsPageLoading: false, // 报工-零部件按钮loading
        isWipCompletionPageLoading: false, // 入库-零部件按钮loading
        isCompletionAssemblyCenterPageLoading: false, // 完工-组装中心按钮loading
        isRowEditSaveBtnLoading: false, // 行编辑时保存按钮loading
        isRowCloseBtnLoading: false // 行编辑时保存按钮loading
      },
      confirmLoading: false,
      pgLoading: false,
      kgLoading: false,
      sorterParams: null
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.columns = JSON.parse(JSON.stringify(this.columns1))
    this.tabOnchange("工单信息")
    this.getProcessingOrganization()
    this.getWorkCodeBox()
    this.getLineCodeBox()
    this.getClassCodeBox()
    this.cacheLookupRequest('MES_JOB_STATUS', { lookupType: 'MES_JOB_STATUS', current: 1, pageSize: 999 }, 'statusList')
    this.cacheLookupRequest('MES_JOB_APPROVAL_STATUS', { lookupType: 'MES_JOB_APPROVAL_STATUS', current: 1, pageSize: 999 }, 'approvalStatusList')
    this.getCategoryIdList(true)
    this.getBomWorkshopFindList()
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    // 按工单创建时保存的图纸版本下载安装图纸
    handleDownloadDrawing () {
      if (this.selectedRows.length === 0) {
        return this.$message.warning('请勾选需要下载图纸的工单')
      }
      if (this.selectedRows.length > 50) {
        return this.$message.warning('单次最多下载50个工单的图纸')
      }
      const missingVersionRows = this.selectedRows.filter(item => !item.drawingVersion)
      if (missingVersionRows.length > 0) {
        const names = missingVersionRows.slice(0, 10).map(item => item.wipEntityName).join('、')
        const suffix = missingVersionRows.length > 10 ? `等${missingVersionRows.length}项` : ''
        return this.$message.warning(`以下工单未关联图纸版本：${names}${suffix}`)
      }

      const fileName = `安装图纸_${moment().format('YYYYMMDD-HHmmss')}.zip`
      this.drawingDownloadLoading = true
      apiMesDispatchDownloadDrawing(this.selectedRows.map(item => item.id), fileName)
        .finally(() => {
          this.drawingDownloadLoading = false
        })
    },
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(valField, listField) {
      const listVal = []
      if (this.queryParams[valField]) {
        const list = this.queryParams[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      this.queryParams[listField] = listVal
    },
    // 时间编辑
    onEditDate(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      // 计划开始时间、计划完成时间,未下达、已下达、已发放、已派工、已开工的状态都能修改
      if(['scheduledStartDate', 'scheduledCompletionDate'].includes(field)) {
        const findNoAllow = this.selectedRows.find(item => !['UNRELEASED', 'RELEASED', 'ISSUED', 'DISPATCHED', 'START_WORK'].includes(item.status))
        if(findNoAllow) {
          return this.$message.warning("只有‘未下达’‘已下达’‘已发放’‘已派工’‘已开工’状态才能修改")
        }
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field)
    },
    // 打印领料单
    handlePrintPicking() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据")
      }
      this.$refs.pickMaterialModalRef.show(this.selectedRows, 'workOrderSent')
    },
    // 刷新包件版本
    handleRefresh() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行刷新")
      }
      if (this.selectedRows.length > 1) {
        return this.$message.warning("只能勾选一条数据进行刷新")
      }
      if (this.selectedRows[0].wipEntityFlag !== 'FINISHED_PRODUCT_JOB') {
        return this.$message.warning("只有成品工单可以刷新包装版本")
      }
      // 除了未下达、已下达、已发放、已开工、已派工、已完成，其他状态，不允许变更包件信息
      const refreshStatus = ['UNRELEASED', 'RELEASED', 'ISSUED', 'DISPATCHED', 'START_WORK', 'COMPLETED']
      const findNoAllow = this.selectedRows.find(item => !(refreshStatus.includes(item.status)))
      if (findNoAllow) {
        return this.$message.warning(`${this.selectedRows[0].statusName}状态不允许变更包件信息`)
      }
      this.$refs.RefreshVersionModalRef.show(this.selectedRows[0], 'workOrderSent')
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 车间编码
    getBomWorkshopFindList () {
      this.queryParams.workshopCodes = undefined;
      this.workshopCodeList = []
      if (!this.organizationCodeOrigin) {
        return false
      }
      apiBomWorkshopFindList({ organizationCode: this.organizationCodeOrigin }).then(res => {
        this.workshopCodeList = res
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
              this.handleQuery('查询')
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.handleQuery('查询')
    },
    workCodeChange (record) {
      record.lineCode = undefined
    },
    handleScheduledCompletionDateChange (value, mode) {
      this.queryParams.staScheduledCompletionDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endScheduledCompletionDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    handleReleaseDateChange (value) {
      this.queryParams.staReleaseDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endReleaseDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    handleScheduledStartDateChange (value, mode) {
      this.queryParams.staScheduledStartDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endScheduledStartDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    handleDeliveryDate (value, mode) {
      this.queryParams.staDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 考核交期
    handleAssessmentDeliveryDate (value) {
      this.queryParams.staAssessmentDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endAssessmentDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 未完成数量交期
    handleEstimatedDeliveryDate (value) {
      this.queryParams.staEstimatedDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endEstimatedDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 提交
    handleconfirm (selectedRows) {
      let flag = false
      for (let i = 0; i < selectedRows.length; i++) {
        if (!(selectedRows[i].status === "ISSUED" || selectedRows[i].approvalStatus === "NEW" || selectedRows[i].approvalStatus === "REJECTED")) {
          this.$message.error("不符合审批条件，请检查！")
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.btnLoadingObj.isSubmitToLoading = true
      this.confirmLoading = true
      apiMesDiscreteJobsSubmitTo({ ids: this.selectedRowKeys }).then(response => {
        if (response.code === 200) {
          this.$message.success('提交成功!')
          this.getList()
        } else {
          this.$message.error(response.msg)
        }
        this.btnLoadingObj.isSubmitToLoading = false
      }).catch(() => {
        this.btnLoadingObj.isSubmitToLoading = false
        this.confirmLoading = false
      }).finally(() => {
        this.btnLoadingObj.isSubmitToLoading = false
        this.confirmLoading = false
      })
    },
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch (changePage) {
      this.isEdit = false
      this.queryParams.desOrganizationCode = this.organizationCodeOrigin
      this.$nextTick(() => {
        this.$refs.dataTable.searchParams = { ...this.queryParams, ...this.sorterParams };
        const self = this;
        const DTDate = this.$refs.dataTable.getData(changePage);

        DTDate.then(function (response) {
          // 在这里处理返回的结果
          if (self.currentTab === "工单信息") {
            const arr = []
              const arr2 = []
              response.data.data.records.forEach(element => {
                arr.push(element.id)
                arr2.push(element.orderNo)
              });
              // self.queryParams.wipEntityIds = arr
              self.orderNos = Array.from(new Set(arr2))

              self.typeList = response.rows
              self.total = response.total
              self.tableLoading = false
          }
        })
      })
    },
    // 打印派工资料
    getSendMaterialsData (ids) {
      this.pgzlLoading = true
      this.showPintSendMaterial = false
      apiMesDispatchPrintDispatchInformation(ids).then(res => {
        if (res?.code === 200 && res?.data && res?.data?.length > 0) {
          this.showPintSendMaterial = true
          setTimeout(() => {
            this.$refs.sendMaterialsRef.show(res.data)
            this.$refs.sendMaterialsBtn.$el.dispatchEvent(new MouseEvent("click"))
          }, 200)
        } else {
          this.$message.warning("无派工资料打印数据！")
        }
        this.pgzlLoading = false
      }).catch(e => {
        this.pgzlLoading = false
      })
    },
    // 五金箱打印标签
    handleHardwarePrint(selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if(selectedRows[0].jobType !== "WJ_STANDARD" || selectedRows[0].wipEntityFlag !== "COMPONENT_JOB") {
        this.$message.warning("请选择五金工单，零部件工单打印！")
        return
      }
      this.hardwareLoading = true
      // 获取打印数据
      apiGetHardwarePrintDetail({ wipEntityId: this.selectedRows[0].id }).then(res => {
        if(res?.code === 200) {
          this.$refs.hardwareLabelPrintRef.show(res.data)
          this.$refs.hardwareLabelBtn.$el.dispatchEvent(new MouseEvent("click"))
        }
      }).finally(() => {
        this.hardwareLoading = false
      })
    },
    // 打印合格证/标签
    handleHezBq (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (selectedRows[0].status === "DISPATCHED" ||
          selectedRows[0].status === "START_WORK" ||
          selectedRows[0].status === "COMPLETED" ||
          selectedRows[0].status === "RECEIVED" ||
          selectedRows[0].status === "ABNORMAL_COMPLETION" ||
          selectedRows[0].status === "CLOSED"
        ) {
        if (selectedRows[0].wipEntityFlag === "FINISHED_PRODUCT_JOB") {
          this.$refs.printCertificate.show(selectedRows[0].id, selectedRows[0])
        } else {
          this.$message.error("该按钮只允许成品工单用于打印合格证和标签")
        }
      } else {
        this.$message.error("工单未派工")
      }
    },
    // 修改考核交期
    handleUpdateAssessmentDelivery() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      const ids = this.selectedRows.map(item => item.id)
      this.deliveryLoading = true
      apiCheckAssessmentDeliveryDateCanSubmit(ids).then(res => {
        if(res?.code === 200 && res?.data === true) {
          this.$refs.updateAssessmentDeliveryDateRef.show(this.selectedRows, 'workOrderSent')
        } else {
          this.$message.error('超出考核交期，无法发起修改考核交期')
        }
      }).finally(() => {
        this.deliveryLoading = false
      })
    },
    // 打印派工资料
    handlePgzl (selectedRows) {
      let flag = false
      for (let i = 0; i < selectedRows.length; i++) {
        if (!this.pgzlList.includes(selectedRows[i].status)) {
          this.$message.warning('工单状态不允许打印')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.getSendMaterialsData(this.selectedRowKeys)
    },
    // 开工
    handleKg (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (selectedRows[0].status === "DISPATCHED") {
        this.btnLoadingObj.isStartWorkLoading = true
        this.kgLoading = true
        apiMesDispatchStartWork(selectedRows[0].id).then(response => {
          if (response.code === 200) {
            this.$message.success('开工成功!')
            this.getList()
          } else {
            this.$message.error(response.msg)
          }
          this.btnLoadingObj.isStartWorkLoading = false
        }).finally(() => {
          this.btnLoadingObj.isStartWorkLoading = false
          this.kgLoading = false
        })
      } else {
        this.$message.error(`工单状态${selectedRows[0].statusName}不符合开工要求`)
      }
    },
    // 报工-零部件
    handleBglbj (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (selectedRows[0].status === "DISPATCHED" || selectedRows[0].status === "START_WORK") {
        if (selectedRows[0].wipEntityFlag === "COMPONENT_JOB") {
          this.btnLoadingObj.isWorkReportingPartsPageLoading = true
          apiMesDispatchWorkReportingPartsPage(selectedRows[0].id).then(response => {
            if (response.code === 200 && response.data && response.data.length > 0) {
              this.$refs.bglbjDialog.show(response.data)
            }
            this.btnLoadingObj.isWorkReportingPartsPageLoading = false
          }).catch(() => {
            this.btnLoadingObj.isWorkReportingPartsPageLoading = false
          })
        } else {
          this.$message.error("该按钮只允许作用于零部件工单进行报工")
        }
      } else {
        this.$message.error(`工单状态${selectedRows[0].statusName}不符合报工要求`)
      }
    },
    // 入库-零部件
    handleWglbj (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (selectedRows[0].status === "COMPLETED") {
        if (selectedRows[0].wipEntityFlag === "COMPONENT_JOB") {
          this.btnLoadingObj.isWipCompletionPageLoading = true
          apiMesDispatchWipCompletionPage(selectedRows[0].id).then(response => {
            if (response.code === 200 && response.data) {
              const arr = []
              arr.push(response.data)
              this.$refs.wglbjDialog.show(arr, selectedRows[0])
            }
            this.btnLoadingObj.isWipCompletionPageLoading = false
          }).catch(() => {
            this.btnLoadingObj.isWipCompletionPageLoading = false
          })
        } else {
          this.$message.error("该按钮只允许作用于零部件工单进行完工")
        }
      } else {
        this.$message.error(`工单状态${selectedRows[0].statusName}不符合入库要求`)
      }
    },
    // 成品质检
    handleCpzj (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }

      if (selectedRows[0].status === "START_WORK") {
        if (selectedRows[0].wipEntityFlag === "FINISHED_PRODUCT_JOB") {
          if (selectedRows[0].inspectMode) {
            this.$refs.cpzjDialog.showNew(selectedRows[0].id)
          } else {
            // inspectionAssemblyCenter(selectedRows[0].id, { pageNum: 1, pageSize: 10 }).then(res => {
            //   if (res.code === 200 && res.data && res.data.orInspectMode) {
                this.$refs.cpzjDialog.show(selectedRows[0].id)
            //   }
            // })
          }
        } else {
          this.$message.error("该按钮只允许作用于成品工单进行报检")
        }
      } else {
        this.$message.error(`工单状态${selectedRows[0].statusName}不符合成品报检要求`)
      }
    },
    // 完工-组装中心
    handleWgzzzx (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (selectedRows[0].status === "START_WORK") {
        if (selectedRows[0].wipEntityFlag === "FINISHED_PRODUCT_JOB") {
          this.$refs.wgzzzxDialog.show(selectedRows[0])
        } else {
          this.$message.error("该按钮只允许作用于成品工单进行完工")
        }
      } else {
        this.$message.error(`工单状态${selectedRows[0].statusName}不符合完工要求`)
      }
    },
    // 派工
    handlePg (selectedRows) {
      if (selectedRows.length === 1) {
        if (selectedRows[0].status === "ISSUED") {
          if (selectedRows[0].approvalStatus === "APPROVED") {
            if (selectedRows[0].wipEntityFlag === "FINISHED_PRODUCT_JOB") {
              this.btnLoadingObj.isAddLoading = true
              const arr = JSON.parse(JSON.stringify(selectedRows))
              const arr5 = []
              arr.forEach(element => {
                delete element.createTime
                delete element.updateTime
              });
              arr5.push(arr)
              this.pgLoading = true
              apiMesDispatchAdd(arr5).then(response => {
                if (response.code === 200) {
                  this.$message.success('派工成功')
                  this.getList()
                } else {
                  this.$message.error(response.msg)
                }
                this.pgLoading = false
              }).catch(() => {
                this.pgLoading = false
              }).catch(e => {
                this.pgLoading = false
              })
            } else {
              this.$refs.createModal.show(selectedRows)
            }
          } else {
            this.$message.error("工单未审批，不允许报工")
          }
        } else {
          this.$message.error(`工单状态${selectedRows[0].statusName}不符合派工要求`)
        }
      }
      if (selectedRows.length > 1) {
        let flag = false
        for (let i = 0; i < selectedRows.length; i++) {
          if (selectedRows[i].status !== "ISSUED") {
            this.$message.error(`工单状态${selectedRows[0].statusName}不符合派工要求`)
            flag = true
            return
          }
          if (selectedRows[i].approvalStatus !== "APPROVED") {
            this.$message.error("工单未审批，不允许报工")
            flag = true
            return
          }
        }
        if (flag) {
          return false
        }
        this.btnLoadingObj.isAddLoading = true
        const arr2 = JSON.parse(JSON.stringify(selectedRows))
        const arr4 = []
        arr2.forEach(element => {
          delete element.createTime
          delete element.updateTime
          const arr3 = []
          arr3.push(element)
          arr4.push(arr3)
        });
        apiMesDispatchAdd(arr4).then(response => {
          if (response.code === 200) {
            this.$message.success('派工成功')
            this.getList()
          } else {
            this.$message.error(response.msg)
          }
          this.btnLoadingObj.isAddLoading = false
        }).catch(() => {
          this.btnLoadingObj.isAddLoading = false
          this.pgLoading = false
        }).catch(e => {
          this.pgLoading = false
        })
      }
    },
    // 发放
    handleFf (ids) {
      const self = this
      // this.$confirm({
      //   title: '警告',
      //   content: `真的要发放 编码编号为${ids}的数据项吗?`,
      //   okText: '发放',
      //   okType: 'danger',
      //   cancelText: '取消',
      //   onOk () {
        this.btnLoadingObj.isGrantLoading = true
          apiMesDiscreteJobsGrant({ ids: ids }).then(response => {
            if (response.code === 200) {
              self.$message.success('发放成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
            this.btnLoadingObj.isGrantLoading = false
          }).catch(() => {
            this.btnLoadingObj.isGrantLoading = false
          })
      //   }
    },
    // 发放&派工撤回
    handleFfFgch (selectedRows) {
      if (selectedRows.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要发放&派工撤回 工单号为${selectedRows[0].wipEntityName}的数据项吗?`,
        okText: '发放&派工撤回',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.btnLoadingObj.isReleaseAndDispatchRecallLoading = true
          apiMesDispatchReleaseDispatchRecall(self.selectedRowKeys[0]).then(response => {
            if (response.code === 200) {
              self.$message.success('发放&派工撤回成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
            this.btnLoadingObj.isReleaseAndDispatchRecallLoading = false
          }).catch(() => {
            this.btnLoadingObj.isReleaseAndDispatchRecallLoading = false
          })
        }
      })
    },
    moment,
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
      this.cacheEditObj = deepClone(record)
    },
    // 编辑-保存
    handleSave (record) {
      if (this.btnLoadingObj.isRowEditSaveBtnLoading) {
        return
      }
      if (!record.desOrganizationName) {
        this.$message.warning('加工组织不能为空')
        return
      }
      if (!record.workCode) {
        this.$message.warning('车间不能为空')
        return
      }
      if (!record.lineCode) {
        this.$message.warning('产线不能为空')
        return
      }
      if (!record.mrpFlag) {
        this.$message.warning('MRP净值不能为空')
        return
      }
      if (!record.scheduledStartDate) {
        this.$message.warning('计划开始时间不能为空')
        return
      }
      if (!record.scheduledCompletionDate) {
        this.$message.warning('计划完成时间不能为空')
        return
      }
      const obj = JSON.parse(JSON.stringify(record))
      obj.scheduledStartDate = obj.scheduledStartDate ? this.$moment(obj.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      obj.scheduledCompletionDate = obj.scheduledCompletionDate ? this.$moment(obj.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      this.btnLoadingObj.isRowEditSaveBtnLoading = true
      apiMesDiscreteJobsUpdate(obj).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false;
          this.getList()
        } else {
          this.$message.error(response.msg)
        }
        this.btnLoadingObj.isRowEditSaveBtnLoading = false
      }).catch(() => {
        this.btnLoadingObj.isRowEditSaveBtnLoading = false
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.getList()
    },
    // 关闭工单
    handleClose(ids) {
      this.btnLoadingObj.isRowCloseBtnLoading = true
      apiMesDiscreateBatchClose(ids).then(response => {
        if (response.code === 200) {
          this.$message.success('关闭工单成功!')
          this.getList()
        } else {
          this.$message.error(response.msg)
        }
        this.btnLoadingObj.isRowCloseBtnLoading = false
      }).catch(() => {
        this.btnLoadingObj.isRowCloseBtnLoading = false
      })
    },
    // 页签-切换
    tabOnchange (val) {
      this.currentTab = val
      if (val === "工单信息") {
        const obj = {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
        const obj2 = JSON.parse(JSON.stringify(this.columns1))
        obj2.push(obj)
        this.columns = obj2
        this.scrollWidth = 4200
        this.$nextTick(() => { this.$refs.dataTable.selection = true })
      }
      if (val === "工单用料表") {
        this.columns = JSON.parse(JSON.stringify(this.columns2))
        this.scrollWidth = 2500
        this.$nextTick(() => { this.$refs.dataTable.selection = false })
        // this.gdylb()
      }
      if (val === "工单工序") {
        this.columns = JSON.parse(JSON.stringify(this.columns3))
        this.scrollWidth = 2200
        this.$nextTick(() => { this.$refs.dataTable.selection = false })
        // this.gdgx()
      }
      if (val === "关联工单") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.scrollWidth = 4100
        this.$nextTick(() => { this.$refs.dataTable.selection = false })
        // this.glgd()
      }
      this.handleQuery()
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      // let url = ""
      if (this.currentTab === "工单信息") {
        // url = 'mes/mesDiscreteJobs/dispatch/export'
        this.exportUrl = apiDiscreteJobsExport
      } else if (this.currentTab === "工单用料表") {
        // url = 'mes/mesRequirementOperations/dispatch/export'
        this.exportUrl = apiRequirementOperationsExport
      } else if (this.currentTab === "工单工序") {
        // url = 'mes/mesOperations/dispatch/export'
        this.exportUrl = apiMesOperationsExport
      } else if (this.currentTab === "关联工单") {
        // url = 'mes/mesDiscreteJobs/dispatch/associatedWorkOrder/export'
        this.exportUrl = apiAssociatedWorkOrderExport
      }
      this.$nextTick(() => {
        const params = { ...this.queryParams }
        this.$refs.download.openModal(params)
      })
    },
    /** 查询快码类型列表 */
    getList () {
      this.currentTab === "工单信息" && this.gdxx()
      this.currentTab === "工单用料表" && this.gdylb()
      this.currentTab === "工单工序" && this.gdgx()
      this.currentTab === "关联工单" && this.glgd()
    },
    // 工单信息
    gdxx () {
      this.tableProps.requestApi = generateLsTableResData(apiMesDiscreteJobsDispatchList, true)
      this.queryParams.wipEntityIds = []
      this.onSearch()
    },
    // 工单用料表
    gdylb () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesRequirementOperationsDispatchList, true));
      this.onSearch()
    },
    // 工单工序
    gdgx () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesOperationsDispatchList, true));
     this.onSearch()
    },
    // 关联工单
    glgd () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesDiscreteJobsDispatchAssociatedWorkOrderList, true));
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery (val) {
      // if (val === "查询" && this.currentTab !== "工单信息") {
      //   return
      // }
      this.onChangeCopyFormExcel('wipEntityNameVal', 'wipEntityNameList')
      this.onChangeCopyFormExcel('orderNoVal', 'orderNoList')
      this.queryParams.pageNum = 1
      this.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        statusList: undefined,
        assemblyItemIdList: undefined,
        lineIdList: undefined,
        desOrganizationCode: undefined,
        classCodeList: undefined,
        orderNoVal: undefined,
        orderNoList: undefined,
        createBy: undefined,
        workshopCodes: undefined,
        scheduledCompletionDate: undefined,
        scheduledStartDate: undefined,
        staEstimatedDeliveryDate: undefined,
        endEstimatedDeliveryDate: undefined,
        approvalStatusList: undefined,
        staReleaseDate: undefined,
        endReleaseDate: undefined
      }
      this.cacheParams = {
        scheduledStartDate: [],
        scheduledCompletionDate: [],
        deliveryDate: [],
        releaseDate: [],
        assessmentDeliveryDate: [], // 考核交期
        estimatedDeliveryDate: [] // 未完成数量交期
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** pageSize 变化的回调 */
    onShowSizeChange (current, pageSize) {
      this.current = current
      this.pageSize = pageSize
      this.queryParams.pageSize = pageSize
      this.queryParams.pageNum = current
      this.getList()
    },
    /** 页码改变的回调 */
    currentPageChange (current, pageSize) {
      this.current = current
      this.pageSize = pageSize
      this.queryParams.pageSize = pageSize
      this.queryParams.pageNum = current
      this.getList()
    },
    // 加工组织
    getProcessingOrganization () {
      apiUserInventOrg().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.desOrganizationNameList = res.data;
        }
      })
    },
    // 车间
    getWorkCodeBox () {
      apiMesDiscreteJobsWorkCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.workCodeList = res.data;
        }
      })
    },
    // 产线
    getLineCodeBox () {
      apiMesDiscreteJobsLineCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.lineCodeList = res.data;
        }
      })
    },
    // 工单分类
    getClassCodeBox () {
      apiMesDiscreteJobsClassCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.classCodeList = res.data;
        }
      })
    },
    handleTableChange (pagination, filters, sorter, { currentDataSource }) {
      console.log(sorter)
      if (this.currentTab === "工单信息") {
        const obj = []
        if (sorter.order) {
          if (sorter.columnKey === "statusName") {
            obj.push({
              fieldName: 'status',
              order: sorter.order === 'ascend' ? 'asc' : 'desc'
            })
          } else {
            obj.push({
              fieldName: sorter.columnKey,
              order: sorter.order === 'ascend' ? 'asc' : 'desc'
            })
          }
        }
        this.sorterParams = {
          order: obj
        }

        if (this.timer) {
          return
        }
        this.timer = setTimeout(() => {
          this.timer = null
          this.onSearch(true)
        }, 100)
      } else {
        this.sorterParams = null
      }
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
.ellipsis{
  display:block;
  width:118px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.itemcode{
  /deep/.ant-form-item-children{
    display: flex;
    align-items: center;
  }
}
.page-header-content{
  /deep/.ant-select{
    width: 140px !important;
  }
  /deep/.ant-calendar-picker{
    min-width: 160px !important;
  }
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
.line-height37 {
  line-height: 37px;
}
.display-none {
  display: none
}
</style>
